export var BorderRadius;
(function (BorderRadius) {
    BorderRadius["OuterBlockRadius"] = "32px";
    BorderRadius["InnerBlockRadius"] = "24px";
    BorderRadius["componentRadius"] = "16px";
    BorderRadius["labelRadius"] = "8px";
    BorderRadius["alert"] = "50px";
})(BorderRadius || (BorderRadius = {}));
